import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from '../../shared';
import { BlogPage } from  '../blog-page';

@Component({
  selector: 'linescape-launches-sailing-schedule',
  template: require('./linescape-launches-sailing-schedule.component.html'),
  styles: [require('./../blog.component.scss'), require('./linescape-launches-sailing-schedule.component.scss')]
})
export class LinescapeLaunchesSailingScheduleComponent extends BlogPage {
  title = "Linescape Launches Sailing Schedule API for Data-on-Demand - Linescape";
  description = "Leading Sailing Schedule data provider launches its first API as an exciting new alternative solution to its traditional bulk data feeds.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/linescape-launches-sailing-schedule/linescape-launches-sailing-schedule.component.ts